import React from 'react';
import { connect } from 'react-redux';
import * as actionTypes from '../../../store/actions/allActionList';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#f5f6fa',
    width: 'inherit',
  },
}));

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > div': {
      maxWidth: 40,
      width: '100%',
      backgroundColor: '#4d74ba',
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    color: '#4d74ba',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(24),
    marginRight: theme.spacing(1),
    '&:focus': {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const StyledTabsCmp = ({ value, onSetNewValue }) => {
  const classes = useStyles('');

  return (
    <div className={classes.root}>
      <StyledTabs value={value} onChange={onSetNewValue} aria-label='styled tabs example'>
        <StyledTab label='Sign In' />
        <StyledTab label='Sign Up' />
      </StyledTabs>
    </div>
  );
};

const mapStateToProps = ({ modals }) => ({
  value: modals.authTabValue,
});

const mapDispatchToProps = (dispatch) => ({
  onSetNewValue: (e, nv) =>
    dispatch({ type: actionTypes.SET_AUTH_TAB_VALUE, newValue: nv }),
});

export default connect(mapStateToProps, mapDispatchToProps)(StyledTabsCmp);
